import React from "react";
import LocationData from "../../data/contact/LocationData.json";
import { useSelector } from "react-redux";
import { media_url } from "../../hooks/useBlog";

const allData = LocationData;

const ContactLocation = () => {
  const { currentCustomer } = useSelector((state) => state.store);
  return (
    <>
      <div className="col-lg-3 col-sm-6">
        <div className="office-location">
          <div className="thumbnail">
            <img src={media_url(currentCustomer?.logo)} alt="Office" />
          </div>
          <div className="content">
            <h4 className="title">{"SEDE"}</h4>
            <p>{currentCustomer?.address || "Gestión Ciudad, Venezuela"}</p>
          </div>
        </div>
      </div>
      {/* {allData.map((data, index) => (
        <div className="col-lg-3 col-sm-6" key={index}>
          <div className="office-location">
            <div className="thumbnail">
              <img src={process.env.PUBLIC_URL + data.thumb} alt="Office" />
            </div>
            <div className="content">
              <h4 className="title">{data.title}</h4>
              <p>{data.address}</p>
            </div>
          </div>
        </div>
      ))} */}
    </>
  );
};

export default ContactLocation;
